module.exports = __webpack_public_path__ + "components/outside-promo-page/static/wave-171035b798e16ae10cc56d27f73deef3.webp";